import { defineMessages } from "react-intl";
export var messages = defineMessages({
  label: {
    id: "jutro-components.widgets.accordion.open",
    defaultMessage: "Label"
  }
});